module.exports = "/packs/images/homepage/facilities/venues_tablet~442a75793bbe0a394ac7bce749d79c23.jpg";